<template>
  <div id="printBodyPaysheet">
    <table class="table table-sm table-bordered mb-5">
      <tbody>
      <tr>
        <td>Организация: {{org.name}}</td>
      </tr>
      </tbody>
    </table>

    <h4 class="text-center">Платежная ведомость № ______ за {{ getMonthName(month) + ' ' + year }}</h4>
    <p class="text-right">Количество листов ________________</p>

    <table class="table table-borderless">
      <tbody>
      <tr>
        <td width="30%">По настоящей ведомости выплачено, тенге</td>
        <td align="center" class="border-bottom">
        </td>
      </tr>
      <tr>
        <td width="30%">и депонировано</td>
        <td align="center" class="border-bottom">
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-borderless">
      <tbody>
      <tr>
        <td width="20%">Расходный кассовый ордер</td>
        <td align="center" class="border-bottom">
        </td>
      </tr>
      <tr>
        <td width="20%"></td>
        <td align="center">
          <small class="text-muted">Номер и дата</small>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-borderless">
      <tbody>
      <tr>
        <td width="20%">Проверил бухгалтер</td>
        <td align="center" class="border-bottom">
        </td>
      </tr>
      <tr>
        <td width="20%"></td>
        <td align="center">
          <small class="text-muted">Подпись, расшифровка подписи</small>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-bordered table-striped table-12">
      <tbody>
      <tr>
        <th>№</th>
        <th>Фамилия Имя Отчество</th>
        <th>Сумма в тенге</th>
        <th>Расписка в получении</th>
      </tr>
      <template v-for="(item, index) in list">
        <tr :key="index">
          <td>{{index + 1}}</td>
          <td>{{ item.last_name + ' ' + item.first_name + ' ' + item.middle_name }}</td>
          <td>{{item.res_worker}}</td>
          <td></td>
        </tr>
      </template>
      </tbody>
    </table>


    <table class="table table-borderless">
      <tr>
        <td width="20%">Ведомость составил</td>
        <td align="center">
          <div class="row border-bottom" style="height: 2rem">
            <div class="col-4"></div>
            <div class="col-8"></div>
          </div>

          <small class="text-muted">Подпись, расшифровка подписи</small>
        </td>
      </tr>
      <tr>
        <td width="20%">Ведомость проверил</td>
        <td align="center">
          <div class="row border-bottom" style="height: 2rem">
            <div class="col-4"></div>
            <div class="col-8"></div>
          </div>
          <small class="text-muted">Подпись, расшифровка подписи</small>
        </td>
      </tr>
    </table>


  </div>
</template>


<script>
export default {
  props: ['list', 'year', 'month', 'org']
}
</script>


<style>

</style>